/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AutoResizingCanvas from '../../../AutoResizingCanvas';
import ComponentBase from '../../../ComponentBase';
import InjectableComponent from '../../ComponentReference/InjectableComponent';

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default abstract class OrientationComponentBase extends ComponentBase
{
    /** @hidden */
    protected canvas: InjectableComponent<AutoResizingCanvas> = new InjectableComponent<AutoResizingCanvas>();

    protected setContexts(): void
    {
        super.setContexts();
        this.canvas.SetContext(AutoResizingCanvas);
    }

    protected start(): void
    {
        super.start();

        if (!CC_EDITOR)
        {
            this.canvas.Value.AddOnOrientationChangeHandler(() => this.onOrientationChanged());
            this.onOrientationChanged();
        }
    }

    public abstract SwitchOrientation(isLandscape: boolean): void;

    protected onOrientationChanged(): void
    {
        this.SwitchOrientation(this.canvas.Value.IsLandScape);
    }
}
